// Packages
const resolveConfig = require("tailwindcss/resolveConfig")
import {
  getImage,
  IGatsbyImageData,
  withArtDirection,
} from "gatsby-plugin-image"
import tailwindConfig from "../../tailwind.config.js"
import { navigate } from "gatsby"
export const { theme } = resolveConfig(tailwindConfig)
import parsePhoneNumber from "libphonenumber-js"

type getValueFromScreenSizeProps = {
  values: {
    desktop: string
    mobile: string
    tablet: string
  }
  screenBreakpoints?: {
    desktop: number
    mobile: number
    tablet: number
  }
  windowWidth: number
}
const screenSizeDefaultProps = {
  screenBreakpoints: {
    desktop: parseInt(theme.screens.desktop.min) - 1,
    desktopMax: parseInt(theme.screens.desktop.max),
    mobile: parseInt(theme.screens.mobile.min) - 1,
    mobileMax: parseInt(theme.screens.mobile.max),
    tablet: parseInt(theme.screens.tablet.min) - 1,
    tabletMax: parseInt(theme.screens.tablet.max),
  },
}
export const screenSizeMaxDefaultProps = {
  screenBreakpoints: {
    desktop: parseInt(theme.screens.desktop.max),
    mobile: parseInt(theme.screens.mobile.max),
    tablet: parseInt(theme.screens.tablet.max),
  },
}
export const getValueFromScreenSize: Function = (
  propsPassed: getValueFromScreenSizeProps,
) => {
  const props = {
    ...propsPassed,
    screenBreakpoints: {
      ...screenSizeDefaultProps.screenBreakpoints,
      ...propsPassed.screenBreakpoints,
    },
  }
  if (props.windowWidth === 0) return props.values["desktop"]
  return props.windowWidth > props.screenBreakpoints.tablet
    ? props.windowWidth > props.screenBreakpoints.desktop
      ? props.values["desktop"]
      : props.values["tablet"]
    : props.values["mobile"]
}

type getImageFromScreenSizeProps = {
  images: {
    desktop: IGatsbyImageData
    mobile: IGatsbyImageData
    tablet: IGatsbyImageData
  }
  screenBreakpoints?: {
    desktop: number
    mobile: number
    tablet: number
  }
}
export const getImageFromScreenSize: Function = (
  propsPassed: getImageFromScreenSizeProps,
) => {
  const props = {
    ...propsPassed,
    screenBreakpoints: {
      ...screenSizeMaxDefaultProps.screenBreakpoints,
      ...propsPassed.screenBreakpoints,
    },
  }
  return withArtDirection(getImage(props.images["desktop"]), [
    {
      image: getImage(props.images["tablet"]),
      media: `(max-width: ${props.screenBreakpoints.tablet}px)`,
    },
    {
      image: getImage(props.images["mobile"]),
      media: `(max-width: ${props.screenBreakpoints.mobile}px)`,
    },
  ])
}

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
})
export const digitFormatter = new Intl.NumberFormat("en-US", {})

export const getAllLicensedStates = async () => {
  let response = await fetch(`/.netlify/functions/get-licensed-states`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      type: "name",
    }),
  })
  return await response.json()
}

export const getUrlWithParams = ({
  path,
  location,
  queryParamsToAdd,
  queryParamsToDelete,
  hashToAdd,
}) => {
  if (!location) return path
  const queryParamsString = location.search
  const hash = location.hash
  let urlObject = new URL(
    `${location.origin}${
      path && path.match(/^\/.*\/$/)
        ? path
        : !path
          ? location.pathname
          : `${location.pathname}${path}/`
    }${queryParamsString}${hashToAdd ? `#${hashToAdd}` : hash}`,
  )
  if (queryParamsToAdd) {
    for (const queryParamName in queryParamsToAdd) {
      if (!urlObject.searchParams.get(queryParamName)) {
        urlObject.searchParams.set(
          queryParamName,
          queryParamsToAdd[queryParamName],
        )
      }
    }
  }
  if (queryParamsToDelete) {
    for (const queryParamName in queryParamsToDelete) {
      if (
        urlObject.searchParams.has(queryParamName) &&
        urlObject.searchParams.get(queryParamName) ===
          queryParamsToDelete[queryParamName]
      ) {
        urlObject.searchParams.delete(queryParamName)
      }
    }
  }

  return `${urlObject.pathname}${urlObject.search}${urlObject.hash}`
}
export const navigateWithUrlParams = ({
  path,
  location,
  navigateState = {},
  queryParamsToAdd,
  queryParamsToDelete,
  hashToAdd,
}) => {
  const url = getUrlWithParams({
    path,
    location,
    queryParamsToAdd,
    queryParamsToDelete,
    hashToAdd,
  })
  navigate(url, {
    state: navigateState,
  })
}

export const convertPhoneNumberToE164 = ({phoneNumber, countryCode = "US"}) => {
  return parsePhoneNumber(phoneNumber, countryCode)?.number ||
          `+1${phoneNumber.replace(/\D/g, "")}`
}

export const isLinkExternal = link =>
  link.match(/www|\.com|http|https/) ? true : false

export const extractPaidMediaParams = async ({ search, hash }) => {
  const searchParams = search ? new URLSearchParams(search) : null

  let clickIdKeys = {
    "fbclid": "Meta",
    "gbraid": "Google",
    "gclid": "Google",
    "msclkid": "Bing",
    "rdt_cid": "Reddit",
    "tblci": "Taboola",
    "wbraid": "Google"
    // Bing: "msclkid",
    // Google: "gclid",
    // Meta: "fbclid",
    // Taboola: "tblci",
    // Reddit: "rdt_cid",
  }
  let paid_media_click_id_source
  let paid_media_click_id
  const isTaboolaHash = hash.match(/^#tblci/)

  for (const clickIdKey in clickIdKeys) {
    const clickIdCookie = typeof window !== "undefined" && typeof cookieStore !== "undefined" ? await cookieStore.get(clickIdKey): null
    const utmSourceCookie = typeof window !== "undefined" && typeof cookieStore !== "undefined" ? await cookieStore.get("utm_source"): null

    if (searchParams?.has(clickIdKey) || isTaboolaHash || clickIdCookie) {
      paid_media_click_id_source = isTaboolaHash ? "Taboola" : clickIdKeys[clickIdKey] || utmSourceCookie
      paid_media_click_id = isTaboolaHash
        ? hash.replace("#tblci", "")
        : searchParams?.get(clickIdKey) || clickIdCookie?.value
    }
  }

  return {
    paid_media_click_id,
    paid_media_click_id_source: paid_media_click_id_source
      ? paid_media_click_id_source
      : searchParams?.has("utm_source")
        ? "Unknown"
        : undefined,
  }
}

type TotalExperOwnerEmail = {
  email: string
}
type TotalExperOwnerExternalId = {
  external_id: string
}
type TotalExpertGrantAiConsent = {
  communication_agent: string
  communication_channel: string
  channel_target: string // E.164 format
  contact_purpose: string
  capture_source: string
  consent_language: string
  ip_address: string
}
interface CreateTotalExpertProps {
  contactData: {
    customFields: {
      original_lead_source: string
      paid_media_click_id: string | undefined
      paid_media_click_id_source: string | undefined
    }
    email: string
    first_name: string
    grant_consent?: TotalExpertGrantAiConsent
    last_name: string
    phone_cell: string
    owner: TotalExperOwnerEmail | TotalExperOwnerExternalId
    source: string
  }
  errorMessage?: string
  optInData?: {
    phone_number: string
    user: TotalExperOwnerEmail | TotalExperOwnerExternalId
  }
}

export const requiredTeFieldEmptyValueString = "N/A"
export const defaultTeExternalId = `JessicaSwink`
export const defaultApiErrorMessage = "An error has occurred. Please try again later."

const teContactEndpoint =
  "https://pnfuk8ngof.execute-api.us-east-1.amazonaws.com/prod/website-leads"
const netlifyTeContactEndpoint = "/.netlify/functions/total-expert-proxy"

export const updateTotalExpertContact = async ({
  contactData,
  errorMessage = defaultApiErrorMessage,
}) => {
  try {
    let contactResponse = await fetch(netlifyTeContactEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        endpoint: teContactEndpoint,
        data: contactData,
      }),
    })
    let contactResponseData
    if (contactResponse.ok) {
      contactResponseData = await contactResponse.json()
      return Promise.resolve({
        contactResponseData,
      })
    } else {
      console.error(contactResponse)
      if (errorMessage !== "") alert(errorMessage)
      return Promise.reject(contactResponse.statusText)
    }
  } catch (err) {
    if (errorMessage !== "") alert(errorMessage)
    console.error(err)
    return Promise.reject(err)
  }
}
export const createTotalExpertContact = async ({
  contactData,
  optInData,
  errorMessage = defaultApiErrorMessage,
}: CreateTotalExpertProps) => {
  try {
    let allContactData = contactData
    if (optInData) {
      allContactData.grant_consent = {
        communication_agent: "agentic-a-i",
        communication_channel: "phone",
        channel_target:
          convertPhoneNumberToE164({phoneNumber: contactData.phone_cell}),
        contact_purpose: "marketing",
        capture_source: "A web form check box",
        consent_language: "Contact has consented to AI calls",
        ip_address: "1.1.1.1",
      }
    }
    let contactResponse = await fetch(netlifyTeContactEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        endpoint: teContactEndpoint,
        data: allContactData,
      }),
    })
    let optInResponseData
    let contactResponseData
    if (contactResponse.ok) {
      contactResponseData = await contactResponse.json()

      if (optInData) {
        let optInResponse = await fetch(netlifyTeContactEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            endpoint: "https://public.totalexpert.net/v1/sms/opt-in",
            data: { ...optInData, status: "OPTED_IN" },
          }),
        })
        if (optInResponse.ok) {
          optInResponseData = await optInResponse.json()
        } else {
          console.error(optInResponse)
          alert(errorMessage)
          return Promise.reject(optInResponse.statusText)
        }
      }
      return Promise.resolve({
        contactResponseData,
        optInResponseData,
      })
    } else {
      console.error(contactResponse)
      alert(errorMessage)
      return Promise.reject(contactResponse.statusText)
    }
  } catch (err) {
    alert(errorMessage)
    console.error(err)
    return Promise.reject(err)
  }
}

export const getQuestionResponses = ({ questionIds,formData }) => {
  const gaQuestionResponses = {}
  const questionResponses = Object.keys(questionIds)
    .map(question_name => {
      if (formData[question_name]) {
        const responseValue =
          typeof formData[question_name] === "object" &&
          !Array.isArray(formData[question_name])
            ? formData[question_name]?.value
            : Array.isArray(formData[question_name])
              ? formData[question_name].join(", ")
              : formData[question_name]
        const questionObject = {
          question: {
            id: questionIds[question_name],
          },
          response_value: responseValue,
        }
        gaQuestionResponses[question_name] = responseValue

        return questionObject
      }
      return null
    })
    .filter(questionObject => questionObject)
  return {
    questionResponses,
    gaQuestionResponses,
  }
}

export const updateTotalExpertSurveyResponses = async ({
  contactData,
  optInData,
  questionResponses,
  surveyId,
  errorMessage = defaultApiErrorMessage,
}) => {
  try {
    const teContact = await createTotalExpertContact({
      contactData,
      optInData,
      errorMessage,
    })

    const contactId = teContact?.contactResponseData?.id

    let surveyResponseResponse = await fetch(netlifyTeContactEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        endpoint: "https://public.totalexpert.net/v1/contact-survey-responses",
        data: {
          contact: {
            id: contactId,
          },
          survey: {
            id: surveyId,
          },
          owner: {
            ...contactData.owner,
          },
          question_responses: questionResponses,
        },
      }),
    })

    let surveyResponseData
    if (surveyResponseResponse.ok) {
      surveyResponseData = await surveyResponseResponse.json()
      return Promise.resolve({
        surveyResponseData,
      })
    } else {
      console.error(surveyResponseResponse)
      if (errorMessage !== "") alert(errorMessage)
      return Promise.reject(surveyResponseResponse.statusText)
    }
  } catch (err) {
    if (errorMessage !== "") alert(errorMessage)
    console.error(err)
    return Promise.reject(err)
  }
}

export const spamEmailDomains = [
   "brightspherejanitorial.com",
  "businesscoachvas.com",
  "cachehelper.com",
  "certaproofcharlotte.com",
  "circuitprompt.com",
  "fusionescort.com",
  "jmailservice.com",
  "melottogroup.com",
  "oakmonteinsurance.com",
  "parallelaid.com",
  "pinnacleindianapolis.com",
  "pipelinewin.com",
  "primepulsecleaning.com",
  "propageprofiles.com",
  "remotetact.com",
  "smartassistanthub.com",
  "smartremoteva.com",
  "theztresvision.com",
  "thevirtualsalesgroup.com",
  "toptalentvas.com",
  "trustedvirtualteam.com",
  "turbojot.com",
  "vasdirect.com",
  "vas4hire.com",
  "vettedvas.com",
  "virtualhandsupport.com",
  "virtualhelpdesk.pro",
  "virtualteamexpert.com",
  "yourvachoice.com",
]
export const checkIsSpam = ({ email, message, timer }) => {
  if (
    (message &&
      (message.match(/to my images you/g) ||
        message.match(/SEO/g) ||
        message.match(/freelance/g) ||
        message.match(/YourNewSecretWeapon/g) ||
        message.match(/cleaning bid/g) ||
        message.match(/ContactRobotPro/g) ||
        message.match(/copyright/g) ||
        message.match(/complimentary/g) ||
        message.match(/storage.googleapis.com/g) ||
        message.match(/Google Analytics/g) ||
        message.match(/AI/g) ||
        message.match(/automate/g) ||
        message.match(/automation/g) ||
        message.match(/My Advanced Virtual Intelligent System/g) ||
        message.match(/Wikipedia/g))) ||
    message.match(/Virtual Assistant Services/g) ||
    message.match(/Virtual Helpdesk/g)
  ) {
    return true;
  }
  if (spamEmailDomains.find(domain => email.match(domain))) {
    return true
  }
  if (timer < 2) return true
  return false
}
export const checkIsTest = ({ name, email }) => {
  if (name === "test" || email === "test@test.com") {
    return true
  }
  return false
}
